import { LocalForageKeyValueRepo } from '#apps/client-web/app/repositories/local-forage-kv-repo';
import { LocalForageDbService } from '#apps/client-web/app/services/local-forage-db';
import { createModuleLogger } from '#apps/client-web/app/services/logger';

import { type AuditId } from '#packages/data-collection/models/audit';
import { type KeyValueRepo } from '#packages/data-collection/repositories/kv-repo';
import { type LoggingContext } from '#packages/data-collection/types/logging-context';

export type FileContent = Blob | ArrayBuffer;

export type FileStorageOptions = {
  /**
   * Repository used to store file data
   */
  repo: KeyValueRepo<string, FileContent>;
} & LoggingContext;

export class FileStorageService {
  protected readonly repo: KeyValueRepo<string, FileContent>;

  constructor(options: FileStorageOptions) {
    this.repo = options.repo;
  }

  async save({
    fileId,
    content,
  }: {
    fileId: string;
    content: FileContent;
  }): Promise<void> {
    await this.repo.set(fileId, content);
  }

  async load({ fileId }: { fileId: string }): Promise<FileContent | null> {
    return this.repo.get(fileId);
  }

  async delete({ fileId }: { fileId: string }): Promise<void> {
    await this.repo.delete(fileId);
  }

  async upload({}: { auditId: AuditId; fileId: string }): Promise<void> {
    throw new Error('Method not implemented.');
  }
}

const logger = createModuleLogger('file-storage-service');

const fileStorageDatabase = LocalForageDbService.createInstance('file-storage');

const fileStorageRepo = new LocalForageKeyValueRepo({
  db: fileStorageDatabase,
  logger,
});

export const fileStorageService = new FileStorageService({
  repo: fileStorageRepo,
  logger,
});
